import { IconButton, Typography } from "@suraasa/placebo-ui"
import AiToolsImg from "assets/WelcomeDialogOnboarding/PgCTL/SuraasaPlus/ai-tools.webp"
import MasterClassImg from "assets/WelcomeDialogOnboarding/PgCTL/SuraasaPlus/masterclass.webp"
import UserProfileImg from "assets/WelcomeDialogOnboarding/PgCTL/SuraasaPlus/user-profile.webp"
import { Xmark } from "iconoir-react"

import Card from "./Card"

const AiTools = ({ handleClose }: { handleClose: () => void }) => {
  return (
    <div className="p-4">
      <div className="flex items-start justify-between">
        <Typography variant="title3" className="mb-3 max-w-[288px]">
          You’ve Unlocked 3 Months of Suraasa Plus!
        </Typography>
        <IconButton onClick={handleClose}>
          <Xmark />
        </IconButton>
      </div>
      <Typography className="mb-2 text-onSurface-600">
        Your PgCTL journey includes a complimentary 1-year subscription to
        Suraasa Plus, worth ₹35,000. <br />
        <br />
        To get you started, we’ve already unlocked your first 3 months!
      </Typography>
      <div className="grid grid-cols-1 grid-rows-3 gap-2 sm:grid-cols-2 sm:grid-rows-2">
        <Card
          svg={<img src={AiToolsImg} alt="ai-tools" />}
          svgBgClassName="bg-[linear-gradient(180deg,#FFF4E8_0%,#F8F9FA_100%)]"
          title="Unlimited access to AI Tools"
          description="Create lesson plans, quizzes, and handouts in seconds."
        />
        <Card
          svg={<img src={UserProfileImg} alt="user-profile" />}
          svgBgClassName="bg-[linear-gradient(180deg,#E9F7FF_0%,#F8F9FA_100%)]"
          title="Unlimited Job Applications"
          description="Apply to premium teaching roles at top schools worldwide."
        />
        <Card
          svg={<img src={MasterClassImg} alt="masterclass" />}
          svgBgClassName="bg-[linear-gradient(180deg,#FFFBE8_0%,#F8F9FA_100%)]"
          title="Exclusive Masterclasses"
          className="sm:col-span-2"
          description="Get full access to expert-led, certified masterclasses."
        />
      </div>
    </div>
  )
}

export default AiTools
